export const OrderTypeEnum = Object.freeze({MERCHANT:0, MARKETPLACE:1})
